// sharedService.js

import apiClient from "./apiClient";
import { getEmail, getOrgCode } from "../components/shared/util";

export const getUserProfile = async (mainTenantId) => {
  const response = await apiClient.post(`/api/v3/home/getConsoleUserProfile`, {
    email: getEmail(),
    mainTenantId: mainTenantId,
  });
  return response.data;
};
